import React from "react";
import {SwitchProps} from "./Switch.types";
import styles from "./Switch.module.scss"

const Switch = (props: SwitchProps) => {
    return <>
        <input type="checkbox" id="Switch" className={styles.switch} data-testid="Switch" {...props}
               data-zoom={props.zoom}/>
        <label htmlFor="Switch"/>
    </>
};

export default Switch;